import React, { useState, useEffect } from 'react';
import axios from 'axios';

function Newsletter({ filterData }) {

    let [data, setData] = useState([]);
    const [mobileView, setMobileView] = useState(false);


    useEffect(() => {
        setData(filterData);
    }, [filterData])

    const handleResize = () => {
        setMobileView(window.innerWidth <= 768);
    };

    async function fetchData() {
        try {
            const response = await axios.get(`${process.env.REACT_APP_API_URL}/subscribe`);
            setData(response.data);  // Assuming you want to save the response data to state
        } catch (error) {
            console.error('Error:', error);
        }
    }


    async function deleteQuery(id) {
        try {
            await axios.delete(`${process.env.REACT_APP_API_URL}/subscribe/${id}`);
            fetchData();
        } catch (error) {
            console.error('Error:', error);
        }
    }

    useEffect(() => {
        handleResize();

        window.addEventListener('resize', handleResize);
        return () => {
            window.removeEventListener('resize', handleResize);
        };
    }, []);

    return (
        <div className="relative overflow-x-auto shadow-md sm:rounded-lg *:font-sans">
            <table className="w-[83vw] text-sm text-left rtl:text-right text-gray-500 dark:text-gray-400 ">
                <thead className={`text-xs text-gray-700 uppercase bg-gray-50 dark:bg-gray-700 dark:text-gray-400 ${mobileView ? 'ml-[5vw] flex w-[90vw]' : ''}`}>
                    <tr>
                        <th scope="col" className="px-3 py-3 text-sm">Email</th>
                        <th scope="col" className="px-3 py-3 text-sm">Created in</th>
                        <th scope="col" className="px-3 py-3 text-sm">Operations</th>
                    </tr>
                </thead>
                <tbody>
                    {data.map((data, index) => (
                        <tr
                            key={index}
                            className={`${index % 2 === 0
                                ? 'bg-white dark:bg-gray-900'
                                : 'bg-gray-50 dark:bg-gray-800'
                                } border-b dark:border-gray-700  ${mobileView ? ' ml-[5vw] flex flex-col' : ''} `}
                        >
                            <th scope="row" className=" py-4 font-medium whitespace-nowrap dark:text-white">
                                <td className="px-3 py-4 ">{data.email}</td>
                            </th>
                                <td className="px-3 py-4 ">{data.subscribedAt}</td>

                            <td className="px-4 flex flex-col py-2 md:px-0 md:py-2">
                                <button className='bg-red-500 px-2 py-4 my-1 mx-1 text-white rounded-xl duration-300 hover:bg-red-400' onClick={() => { deleteQuery(data._id) }}>Delete</button>
                            </td>
                        </tr>
                    ))}
                </tbody>
            </table>
        </div>
    );

};

export default Newsletter;